export default "__VITE_ASSET__BDw4gMgp__"